import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import providerLocale from '../../components/hoc/providerLocale';
import Step from './Step';

export default compose(
  withRouter,
  providerLocale
)(Step);
